import axiosInstance from "./axiosConfig";

export const getLowStockSummary = async () => {
  try {
    const response = await axiosInstance.get(
      "/products/low-stocks/summary/"
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching low stock summary:", error);
    throw error;
  }
};

export const getLowStockProducts = async (params = {}) => {
  try {
    const response = await axiosInstance.get("/products/low-stocks/", {
      params: {
        page: params.page || 1,
        page_size: params.page_size || 25,
        search: params.search || undefined,
        date_filter: params.date_filter || undefined,
        status: params.status !== "all" ? params.status : undefined,
        ordering: params.ordering || undefined,
      },
    });
    // Return the data in the expected format with results and count
    return {
      results: response.data.data || [],
      count: response.data.data?.length || 0
    };
  } catch (error) {
    console.error("Error fetching low stock products:", error);
    throw error;
  }
};

export const ignoreProduct = async (productId) => {
  try {
    const response = await axiosInstance.patch(
      `/products/low-stocks/${productId}/ignore/`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error ignoring product:", error);
    throw error;
  }
};

